<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { mapGetters, mapState } from "vuex";

let user = JSON.parse(localStorage.getItem("user"));

/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Chi tiết đơn hàng",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  computed: {
    ...mapGetters("service", [
      "getServices",
      "getService",
      "getOpition",
      "getCustomer",
    ]),
  },

  data() {
    return {
      errorSubmit: false,
      noted: "",
      html: "<h1>Nội dung email cần gửi : Bạn nhận được hóa đơn cho đơn hàng {{invoice}}</h1>",
      title: "Dữ liệu mẫu hóa đơn",
      items: [
        {
          text: "Trang chủ",
          href: "/",
        },
        {
          text: "Dữ liệu mẫu hóa đơn",
          active: true,
        },
      ],
      txt: "Lưu ý bắt buộc trong chuỗi phải chứa {{invoice}} để có thể đẩy id hóa đơn vào.",
    };
  },
  methods: {
    saveExapleBillData() {
      let payload = { txt: this.noted, html: this.html };

      axios({
        url: process.env.VUE_APP_SERVER_URL + "/api/bill/example-update",
        method: "post",
        headers: {
          authorization: user.token,
        },
        data: payload,
      })
        .then(({ data }) => {
          this.$toasted.success("dữ liệu hóa đơn đã được cập nhập thành công");
          return data;
        })
        .catch((error) => {
          error && error.message && error.response.data
            ? this.$toasted.error(
                error.response ? error.response.data : error.message
              )
            : this.$toasted.error("Lỗi không xác định xảy ra.");
        });
    },
  },
  async mounted() {
    var seft = this;
    await axios({
      url: process.env.VUE_APP_SERVER_URL + "/api/bill/example-update",
      method: "get",
    })
      .then(({ data }) => {
  
        if (data) {
          seft.noted = data.txt;
          seft.html = data.html;
        }else {
           seft.noted = '';
           seft.html='';
        }

        return data;
      })
      .catch((error) => {
        error && error.message && error.response.data
          ? this.$toasted.error(
              error.response ? error.response.data : error.message
            )
          : this.$toasted.error("Lỗi không xác định xảy ra.");
      });

    ClassicEditor.create(document.querySelector("#editor"), {
      licenseKey: "",
    }).then((editor) => {
      window.editor = editor;
      editor.setData(seft.noted);
      editor.model.document.on("change:data", (evt, data) => {
        seft.noted = editor.getData();
      });
    });

    ClassicEditor.create(document.querySelector("#editor2"), {
      licenseKey: "",
    }).then((editor) => {
      window.editor = editor;
      editor.setData(seft.html);
      editor.model.document.on("change:data", (evt, data) => {
        seft.html = editor.getData();
      });
    });
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="saveExapleBillData">
              <h5 class="text-success">Infomation</h5>
              <div id="editor"></div>

              <h5 class="text-success mt-3">HTML TEMPLATE SEND EMAIl</h5>
              <p>{{ txt }}</p>
              <div id="editor2"></div>
              <button tyle="submit" class="my-3 btn btn-success btn-md">
                Lưu dữ liệu mẫu
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>